<template>
  <div class="menu-list">
    <simple-table :columns="columns">
      <template #tableBody>
        <tr>
          <td
            v-if="!rows.records || rows.records.length == 0"
            :colspan="columns.length"
            align="center"
          >
            No records found.
          </td>
        </tr>
        <tr v-for="(row, index) in rows.records" :key="index">
          <td>{{ row.id }}</td>
          <td>
            <strong>{{ row.title }}</strong>
          </td>
          <td>
            <div class="action-icons">
              <custom-button
                title="Manage Menu"
                iconClass="fa fa-cog"
                @onClicked="onManageClick(row)"
              />
            </div>
          </td>
        </tr>
      </template>
    </simple-table>
  </div>
</template>

<script>
export default {
  props: {
    rows: {
      required: true,
      default: () => {},
    },
  },
  components: {},
  data: () => ({
    columns: [
      {
        label: "Id",
      },
      {
        label: "Menu Name",
      },
      {
        label: "Action",
      },
    ],
    row: null,
  }),
  methods: {
    onSuccess() {
      this.$emit("onSuccess");
    },
    onManageClick(row) {
      this.$emit("onManage", row);
    },
  },
};
</script>

<style >
.menu-list table strong {
  padding: 0 !important;
}
.menu-list .table > :not(:first-child) {
  border-top: none !important;
}
</style>

